(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-card-slider')) {
    class ProductCardSlider extends HTMLElement {
      connectedCallback() {
        this.track   = this.querySelector('.hdt-pr-slider__track');
        this.slides  = Array.from(this.querySelectorAll('.hdt-pr-slider__slide'));
        this.prevBtn = this.querySelector('.hdt-pr-slider__arrow--prev');
        this.nextBtn = this.querySelector('.hdt-pr-slider__arrow--next');

        if (!this.track || this.slides.length <= 1) return;

        this.currentIndex = 0;
        this.isDragging   = false;
        this.wasSwiped    = false;
        this.startX       = 0;
        this.deltaX       = 0;
        this.slideWidth   = 0;

        this.onPrev       = this.onPrev.bind(this);
        this.onNext       = this.onNext.bind(this);
        this.onDragStart  = this.onDragStart.bind(this);
        this.onDragMove   = this.onDragMove.bind(this);
        this.onDragEnd    = this.onDragEnd.bind(this);

        this.prevBtn?.addEventListener('click', this.onPrev);
        this.nextBtn?.addEventListener('click', this.onNext);

        // Prevent the parent <a> from navigating when the user was swiping
        this.parentElement?.addEventListener('click', (e) => {
          if (this.wasSwiped) {
            e.preventDefault();
            e.stopPropagation();
            this.wasSwiped = false;
          }
        });

        this.track.addEventListener('touchstart', this.onDragStart, { passive: true });
        this.track.addEventListener('touchmove',  this.onDragMove,  { passive: true });
        this.track.addEventListener('touchend',   this.onDragEnd);

        this.track.addEventListener('mousedown', this.onDragStart);
        window.addEventListener('mousemove', this.onDragMove);
        window.addEventListener('mouseup',   this.onDragEnd);

        // ResizeObserver: read width only once element has real dimensions
        // (handles PDP AJAX injection where offsetWidth is 0 at connect time)
        this._ro = new ResizeObserver(() => {
          const w = this.offsetWidth;
          if (w > 0) this.slideWidth = w;
          this.track.style.transition = 'none';
          this.track.style.transform  = `translateX(-${this.currentIndex * 100}%)`;
          requestAnimationFrame(() => { this.track.style.transition = ''; });
        });
        this._ro.observe(this);

        this.updateArrowState();
      }

      disconnectedCallback() {
        this._ro?.disconnect();
        window.removeEventListener('mousemove', this.onDragMove);
        window.removeEventListener('mouseup',   this.onDragEnd);
      }

      onPrev(e) { e.preventDefault(); e.stopPropagation(); this.goTo(this.currentIndex - 1); }
      onNext(e) { e.preventDefault(); e.stopPropagation(); this.goTo(this.currentIndex + 1); }

      goTo(index) {
        const max = this.slides.length - 1;
        this.currentIndex = Math.max(0, Math.min(index, max));
        this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
        this.updateArrowState();
        this.updateDots();
      }

      updateArrowState() {
        if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.currentIndex === this.slides.length - 1;
      }

      updateDots() {
        this.querySelectorAll('.md-pr-card__dot').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.currentIndex);
        });
      }

      getClientX(e) {
        return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
      }

      onDragStart(e) {
        const w = this.offsetWidth;
        if (w > 0) this.slideWidth = w;
        if (!this.slideWidth) return;
        this.isDragging = true;
        this.wasSwiped  = false;
        this.startX     = this.getClientX(e);
        this.deltaX     = 0;
        this.track.classList.add('is-dragging');
      }

      onDragMove(e) {
        if (!this.isDragging) return;
        this.deltaX = this.getClientX(e) - this.startX;
        if (Math.abs(this.deltaX) > 6) this.wasSwiped = true;
        const base = -this.currentIndex * this.slideWidth;
        this.track.style.transform = `translateX(${base + this.deltaX}px)`;
      }

      onDragEnd() {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.track.classList.remove('is-dragging');

        const threshold = this.slideWidth * 0.15;
        if      (this.deltaX < -threshold && this.currentIndex < this.slides.length - 1) this.currentIndex++;
        else if (this.deltaX >  threshold && this.currentIndex > 0)                       this.currentIndex--;

        this.goTo(this.currentIndex);
      }
    }

    customElements.define('product-card-slider', ProductCardSlider);
  }

  if (!window.mdCardSwatchBound) {
    window.mdCardSwatchBound = true;
    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-md-card-swatch]');
      if (!swatch) return;
      event.preventDefault();
      event.stopPropagation();
      const card = swatch.closest('hdt-card-product, .hdt-card-product');
      if (!card) return;

      card.querySelectorAll('[data-md-card-swatch]').forEach((item) => {
        item.classList.toggle('is-active', item === swatch);
      });

      const variantId = swatch.getAttribute('data-vid');
      if (variantId) {
        card.querySelectorAll('[data-pr-url]').forEach((link) => {
          try {
            const url = new URL(link.getAttribute('href'), window.location.origin);
            url.searchParams.set('variant', variantId);
            link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
          } catch (err) {}
        });
      }

      const imageUrl = swatch.getAttribute('data-vimg');
      if (!imageUrl) return;

      const mediaImage = card.querySelector('.hdt-card-product__media--main');
      if (mediaImage && mediaImage.tagName === 'IMG') {
        mediaImage.src = imageUrl;
        mediaImage.removeAttribute('srcset');
      }

      const slider = card.querySelector('product-card-slider');
      if (slider && typeof slider.goTo === 'function') slider.goTo(0);
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["md-search-placeholder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("md-search-placeholder")) {
    class MdSearchPlaceholder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === "true") return;
        this.dataset.bound = "true";
        this.suggestions = (this.dataset.suggestions || "")
          .split("|")
          .map((item) => item.trim())
          .filter(Boolean);
        if (this.suggestions.length < 2) return;

        this.index = 0;
        this.holdTimer = null;
        this.typeTimer = null;
        this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onVisibility = this.onVisibility.bind(this);

        this.inputs = Array.from(document.querySelectorAll(".hdt-header-col-search [data-input-search], #drawer-search-form [data-input-search]"));
        if (!this.inputs.length) {
          this.inputs = Array.from(document.querySelectorAll("[data-input-search]"));
        }
        this.inputs.forEach((input) => {
          if (!input.getAttribute("aria-label")) input.setAttribute("aria-label", "Search");
          if (!input.value) input.placeholder = this.suggestions[0];
          input.addEventListener("focus", this.onFocusIn);
          input.addEventListener("blur", this.onFocusOut);
          input.addEventListener("input", this.onFocusOut);
        });

        document.addEventListener("visibilitychange", this.onVisibility);
        this.scheduleHold();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener("visibilitychange", this.onVisibility);
        this.inputs.forEach((input) => {
          input.removeEventListener("focus", this.onFocusIn);
          input.removeEventListener("blur", this.onFocusOut);
          input.removeEventListener("input", this.onFocusOut);
        });
      }

      busy() {
        return this.inputs.some((input) => document.activeElement === input || input.value.trim() !== "");
      }

      idleInputs() {
        return this.inputs.filter((input) => document.activeElement !== input && input.value.trim() === "");
      }

      stop() {
        if (this.holdTimer) {
          clearTimeout(this.holdTimer);
          this.holdTimer = null;
        }
        if (this.typeTimer) {
          clearTimeout(this.typeTimer);
          this.typeTimer = null;
        }
      }

      onFocusIn() {
        this.stop();
      }

      onFocusOut() {
        this.scheduleHold();
      }

      onVisibility() {
        if (document.hidden) this.stop();
        else this.scheduleHold();
      }

      setPlaceholder(text) {
        this.idleInputs().forEach((input) => {
          input.placeholder = text;
        });
      }

      scheduleHold() {
        this.stop();
        if (document.hidden || this.busy()) return;
        this.holdTimer = window.setTimeout(() => this.nextPhrase(), 2200);
      }

      nextPhrase() {
        if (this.busy()) return;
        this.index = (this.index + 1) % this.suggestions.length;
        const next = this.suggestions[this.index];
        if (this.reduceMotion) {
          this.setPlaceholder(next);
          this.scheduleHold();
          return;
        }
        this.deleteThenType(next);
      }

      deleteThenType(next) {
        const current = (this.idleInputs()[0] && this.idleInputs()[0].placeholder) || "";
        const stepDelete = () => {
          if (this.busy()) return;
          const shown = (this.idleInputs()[0] && this.idleInputs()[0].placeholder) || "";
          if (shown.length > 0) {
            this.setPlaceholder(shown.slice(0, -1));
            this.typeTimer = window.setTimeout(stepDelete, 28);
            return;
          }
          this.typeIn(next, 0);
        };
        if (!current) this.typeIn(next, 0);
        else stepDelete();
      }

      typeIn(text, pos) {
        if (this.busy()) return;
        this.setPlaceholder(text.slice(0, pos));
        if (pos < text.length) {
          this.typeTimer = window.setTimeout(() => this.typeIn(text, pos + 1), 48);
          return;
        }
        this.scheduleHold();
      }
    }

    customElements.define("md-search-placeholder", MdSearchPlaceholder);
  }
  } catch(e) { console.error(e); }
})();

})();
